import { Box, darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import styled from "styled-components";

/**
 * Contains style information for the choices product group component.
 */
export const ChoicesProductGroupStyles = makeStyles((theme: Theme) => ({
    root: {
        width: "100%",
    },
    productColumnRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "60px",
    },
    productContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "20px 0",

        "&:not(:last-child)": {
            borderBottom: "1px dashed #ced4da",
        },
    },
    productContentRow: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        maxWidth: "calc(100% - 135px)",
        gap: "10px",
    },
    productContentContainer: {
        display: "flex",
        flexDirection: "column",
        minHeight: "91px",
        width: "100%",
        gap: "10px",
        "& > div:first-child": {
            flex: "1",
            flexDirection: "column",
        },
        "& > div:last-child": {
            display: "flex",
            "& > div": {
                // flex: "1",
                "& > div": {
                    wordBreak: "break-all",
                    whiteSpace: "normal",
                },
            },
        },
    },
    productImageContainer: {
        height: "100px",
        width: "100px",
        minWidth: "100px",
        "& > img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
        },
    },
    productTitleDesc: {
        minWidth: "500px",
    },
    productTitle: {
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "17px",
        color: "#191919",
        letterSpacing: "-0.35px",
        marginBottom: "4px",
    },
    productDescription: {
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "17px",
        color: "#191919",
        letterSpacing: "-0.35px",
    },
    productVariantsContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    productRadio: {
        padding: "3px 10px",
        width: "100%",
        margin: "0px",
        maxHeight: "41px",
        "& > span:last-child > p ": {
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "17px",
            color: "#191919",
            letterSpacing: "-0.35px",
            marginRight: "5px",
        },
    },
    productRadioChecked: {
        border: "1px solid #CED4DA",
        borderRadius: "5px",
        padding: "3px 10px",
        width: "100%",
        margin: "0px",
        backgroundColor: "#50C14A",
        color: "#FFFFFF",
        "& > span > span > div > svg": {
            color: "#FFFFFF",
        },
        "& > span:last-child > p ": {
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "17px",
            color: "#191919",
            letterSpacing: "-0.35px",
            marginRight: "5px",
        },
    },
    radioButton: {
        color: "#7F7F7F",
        padding: "0 5px 0 0",
        "& > span > div > svg": {
            height: "22px",
            width: "22px",
        },
    },
    productCheckbox: {
        border: "none",
        borderRadius: "5px",
        padding: "3px 10px",
        width: "100%",
        margin: "0px",
        maxHeight: "41px",
        "& > span:last-child > p ": {
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "17px",
            color: "#191919",
            letterSpacing: "-0.35px",
            marginRight: "5px",
        },
    },
    productCheckboxChecked: {
        border: "none",
        borderRadius: "5px",
        padding: "3px 10px",
        width: "100%",
        margin: "0px",
        color: "#191919",
        backgroundColor: "none",
        "& > span > span > svg": {
            color: "#7F7F7F",
        },
        "& > span:last-child > p ": {
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "17px",
            color: "#191919",
            letterSpacing: "-0.35px",
            marginRight: "5px",
        },
    },
    productLabel: {
        color: "#191919",
        fontSize: "14px",
        fontWeight: "bold",
        lineHeight: "17px",
        marginRight: "5px",
        letterSpacing: "-0.35px",
    },

    checkboxButton: {
        color: "#7F7F7F",
        padding: "0 5px 0 0",
        "& > span > svg": {
            height: "22px",
            width: "22px",
        },
    },
    subtitle: {
        backgroundColor: "#3C3C3B",
        color: "#FFFFFF",
        padding: "7px 18px",
    },
    productVariantSelect: {
        marginTop: "auto",
        maxWidth: "255px",
    },
    noneoftheabovecontainer: {
        padding: "10px",
        "& > div": {
            padding: "10px",
        },
    },
    productRadioNoneOfTheAbove: {
        border: "1px solid transparent",
        borderRadius: "5px",
        padding: "3px 10px",
        width: "100%",
        margin: "0px",
    },
    priceWrapper: {
        display: "inline-flex",
        alignItems: "center",
        marginRight: "7px",
        position: "relative",
    },

    priceTip: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "14px",
        height: "14px",
        backgroundColor: "#4caf50",
        borderRadius: "50%",
        marginRight: "6px",
        color: "#FFFFFF",
        fontSize: "10px",
        lineHeight: "14px",
        textAlign: "center",
        fontWeight: "bold",
        flexShrink: 0,
    },

    tooltipTrigger: {
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        lineHeight: 1,
    },

    negativePriceTooltip: {
        backgroundColor: "#4caf50",
        color: "#FFFFFF",
        fontSize: "11px",
        lineHeight: "1.3",
        padding: "7px 9px",
        borderRadius: "3px",
        maxWidth: "210px",
        textAlign: "left",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    },

    negativePriceTooltipArrow: {
        color: "#4caf50",
    },
    [theme.breakpoints.up("md")]: {
        productContainer: {
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-between",
        },

        productContentRow: {
            alignItems: "center",
        },
        productRadioNoneOfTheAbove: {
            border: "none",
            color: "#191919",
            margin: "0px",
            "& > span": {
                padding: "0 0 0 10px",
            },
        },
        productRadio: {
            border: "none",
            color: "#191919",
            margin: "0px",
            "& > span": {
                padding: "0 0 0 10px",
            },
        },
        productRadioChecked: {
            background: "none",
            color: "#191919",
            border: "none",
            margin: "0px",
            "& > span": {
                padding: "0 0 0 10px",
            },
            "& > span > span > div > svg": {
                color: "#7F7F7F",
            },
        },

        productVariantSelect: {
            // minWidth: "255px",
            "& .MuiSelect-icon": {
                top: "auto !important",
            },
        },
    },
    counterButton: {
        color: "black",
        width: "30px",
        height: "30px",
        maxWidth: "30px",
        maxHeight: "30px",
        background: "#ffffff 0% 0% no-repeat padding-box",
        border: "1px solid #ced4da",
        cursor: "pointer",
    },
    counterLabel: {
        marginRight: "5px",
        fontWeight: "bold",
    },
    counterInput: {
        width: "60px",

        "& #orderQuantity-input": {
            height: "33px",
            boxSizing: "border-box",
        },
    },
    [theme.breakpoints.down("sm")]: {
        productColumnRow: {
            padding: "0 30px",
            gridTemplateColumns: "1fr",
            columnGap: "0px",
        },
        productContentRow: {
            maxWidth: "100%",
            marginBottom: "20px",
        },
        productTitle: {
            fontSize: "12px",
            lineHeight: "14px",
        },
        productDescription: {
            fontSize: "10px",
            lineHeight: "12px",
        },
        productCheckboxChecked: {
            "& > span:last-child > p ": {
                fontSize: "12px",
                lineHeight: "14px",
            },
        },
        productCheckbox: {
            "& > span:last-child > p ": {
                fontSize: "12px",
                lineHeight: "14px",
            },
        },
        productRadioChecked: {
            "& > span:last-child > p ": {
                fontSize: "12px",
                lineHeight: "14px",
            },
        },
        productRadio: {
            "& > span:last-child > p ": {
                fontSize: "12px",
                lineHeight: "14px",
            },
        },
        productContainer: {
            padding: "30px 0",
        },
    },
}));

export const GridContainerCounter: any = styled(Box)`
    display: flex;
    align-items: center;
`;
